export default __webpack_public_path__ + "static/media/icl_video.797fc7b5.mp4";